<template>
    <div
        v-if="isActive"
        class="ui-loader"
        :style="{
            position: staticLoader ? 'relative' : '',
        }"
    >
        <div class="ui-loader-wrapper flex flex-column items-center">
            <div class="ui-loader__spinner" />
            <div
                v-if="!staticLoader"
                class="ui-loader__logo"
            >
                <LogoSvg />
            </div>
        </div>
    </div>
</template>

<script>
import {computed, defineComponent} from 'vue';

import {useLoaderStore} from '@/stores/loader';
import LogoSvg from '@/assets/images/logo.svg?inline';

export default defineComponent({
    name: 'LoaderComponent',
    components: {
        LogoSvg,
    },
    props: {
        staticLoader: {
            type: Boolean,
            default: () => false,
        },
        forceLoading: {
            type: Boolean,
            default: () => false,
        },
    },
    setup(props) {
        const loader = useLoaderStore();

        const isActive = computed(() => {
            if (props.staticLoader) {
                return true;
            }

            if (props.forceLoading) {
                return true;
            }

            return loader.isActive;
        });

        return {
            isActive,
        };
    },
});
</script>

<style lang="scss" scoped>
.ui-loader {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background-color: rgba(255, 255, 255, 80%);

    &-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &__spinner {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-bottom: 3px solid var(--color-primary-30);
        border-top: 3px solid var(--color-primary-30);
        animation: rotate 1s linear infinite;
    }

    &__logo {
        margin-top: 15px;
        user-select: none;

        svg {
            width: 200px;
            height: 54px;
        }
    }
}
</style>
